export default __webpack_public_path__ + "static/media/attachment-footer-item.27ce2288.svg";